// extracted by mini-css-extract-plugin
export default {"buttonSmall":"buttonSmall_buttonSmall__WJpKa"};